import { FORMAL_QUOTE_OPTIONS } from 'formal_quote/options';

export const selectInlineFormalQuote = (state) => state.inlineFormalQuote;

export const selectShowForm = (state) => state.inlineFormalQuote.showForm;

export const selectDataForRecommendedProduct = (state) => {
  const { formData } = state.inlineFormalQuote;
  const { selectedVariant, product } = state.softwareProducts;

  const getLicenseType = () => {
    // Get license type from variant option values
    const optionValues = selectedVariant?.option_values;
    const variantLicenseType = optionValues?.find((ov) => ov.option_type_name === 'license-type')?.name;

    // Convert variant license type to our license_type format
    let license_type = 'standalone'; // default
    if (variantLicenseType === 'network') {
      license_type = 'network';
    }

    const { portability_option } = formData;

    // Apply the same rules as FormalQuoteForm
    // Network license always results in Network Computer Locked
    if (license_type === 'network') {
      return 'Network Computer Locked';
    }

    // Standalone license depends on portability option
    if (license_type === 'standalone' && portability_option === 'not_needed') {
      return 'Standalone Computer Locked';
    }
    if (license_type === 'standalone' && portability_option === 'any_machine') {
      return 'Standalone Locked to USB Dongle';
    }

    return '';
  };

  // Get delivery method - directly from formData
  const getDeliveryMethod = () => FORMAL_QUOTE_OPTIONS.delivery_method[formData.delivery_method] || '';

  // Get number of users from variant or formData
  const numberOfUsers = (() => {
    const value = formData.number_of_users;
    if (FORMAL_QUOTE_OPTIONS.number_of_users[value]) {
      return FORMAL_QUOTE_OPTIONS.number_of_users[value];
    }
    const count = parseInt(value, 10);
    return !isNaN(count) && count > 0
      ? `${count} User${count === 1 ? '' : 's'}`
      : '';
  })();

  const data = {
    productName: product?.name || '',
    licenseScope:
      FORMAL_QUOTE_OPTIONS.license_scope[formData.license_scope]?.label || '',
    numberOfUsers,
    numberOfUsersLabel: formData.license_scope === 'site'
      ? 'Potential Number of Users'
      : formData.license_scope === 'standard'
        ? 'Number of Licenses'
        : 'Number of Users',
    licenseType: getLicenseType(),
    deliveryMethod: getDeliveryMethod(),
    looking_for: 'new_license',
  };

  return data;
};
